export const allShowedOverlays = ({ allShowedOverlays }) => allShowedOverlays;
export const popupData = ({ popupData }) => popupData;
export const titlePopup = ({ titlePopup }) => titlePopup;
export const buttonPopup = ({ buttonPopup }) => buttonPopup;
export const contentReview = ({ contentReview }) => contentReview;